module.exports = __webpack_public_path__ + "img/5_112.44145e8f.png";